export default __webpack_public_path__ + "assets/8a8ba1fe70427d4f4488bcee0eee2db7.png";